/* By Old Money on Dawn: behaviour the live store has and Dawn does not. */
(function () {
  'use strict';

  /* Desktop menus open on hover, like the live store. Click still works. */
  var hoverMQ = window.matchMedia('(hover: hover) and (min-width: 769px)');
  document.querySelectorAll('.header__inline-menu header-menu details').forEach(function (details) {
    var timer;
    details.addEventListener('mouseenter', function () {
      if (!hoverMQ.matches) return;
      clearTimeout(timer);
      document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(function (d) {
        if (d !== details) d.removeAttribute('open');
      });
      details.setAttribute('open', '');
      var s = details.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'true');
    });
    details.addEventListener('mouseleave', function () {
      if (!hoverMQ.matches) return;
      timer = setTimeout(function () {
        details.removeAttribute('open');
        var s = details.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false');
      }, 120);
    });
  });
})();

/* Card gallery: arrows on desktop, dots + swipe on touch. Slides after the
   first carry no src until the shopper touches the card. */
(function () {
  'use strict';
  var suppressClick = false;
  function hydrate(gal) {
    if (!gal || gal.dataset.hydrated) return;
    gal.dataset.hydrated = '1';
    gal.querySelectorAll('.bom-cardgal__img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
    });
  }
  function paint(gal) {
    var idx = parseInt(gal.dataset.idx || '0', 10);
    gal.querySelectorAll('.bom-cardgal__img').forEach(function (img) {
      img.classList.toggle('is-active', parseInt(img.dataset.idx, 10) === idx);
    });
    gal.querySelectorAll('.bom-cardgal__dots i').forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    gal.classList.toggle('is-browsing', idx !== 0);
  }
  function step(gal, dir) {
    hydrate(gal);
    var count = parseInt(gal.dataset.count || '1', 10);
    var idx = parseInt(gal.dataset.idx || '0', 10);
    gal.dataset.idx = (idx + dir + count) % count;
    paint(gal);
  }
  document.addEventListener('mouseenter', function (e) {
    var wrap = e.target.closest && e.target.closest('.bom-card__media');
    if (wrap) hydrate(wrap.querySelector('[data-bom-cardgal]'));
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bom-cardgal__nav');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      step(btn.closest('[data-bom-cardgal]'), btn.classList.contains('bom-cardgal__nav--next') ? 1 : -1);
      return;
    }
    var dot = e.target.closest && e.target.closest('.bom-cardgal__dots i');
    if (dot) {
      e.preventDefault(); e.stopPropagation();
      var gal = dot.closest('[data-bom-cardgal]');
      hydrate(gal);
      gal.dataset.idx = Array.prototype.indexOf.call(dot.parentNode.children, dot);
      paint(gal);
      return;
    }
    if (suppressClick && e.target.closest('.bom-card__media')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  var sx = 0, sy = 0, active = null;
  document.addEventListener('touchstart', function (e) {
    var wrap = e.target.closest && e.target.closest('.bom-card__media');
    active = wrap ? wrap.querySelector('[data-bom-cardgal]') : null;
    if (!active) return;
    hydrate(active);
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!active) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      step(active, dx < 0 ? 1 : -1);
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 350);
    }
    active = null;
  }, { passive: true });
})();

/* Bridge: Dawn's variant change -> the 'variant:change' event the By Old Money
   sticky add-to-cart bar listens for. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var v = event && event.data && event.data.variant;
    if (v) document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
  });
})();

/* Review bar on the product page jumps to the review carousel; it switches
   itself off when there is none (quick view). */
(function () {
  function init() {
    var bars = document.querySelectorAll('[data-bom-review-jump]');
    var target = document.querySelector('.bom-rv') || document.querySelector('[id*="bom_reviews"]');
    bars.forEach(function (bar) {
      if (bar.dataset.bomBound) return;
      bar.dataset.bomBound = '1';
      if (!target || bar.closest('quick-add-modal')) {
        bar.setAttribute('data-bom-review-jump', 'off');
        bar.setAttribute('tabindex', '-1');
        bar.setAttribute('aria-hidden', 'true');
        bar.disabled = true;
        return;
      }
      bar.addEventListener('click', function () {
        var head = document.querySelector('.section-header sticky-header, .section-header');
        var offset = head ? head.offsetHeight + 12 : 12;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: reduce ? 'auto' : 'smooth' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (e) {}
      });
    });
  }
  init();
  new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
})();

/* Thumbnail strip: keep the active thumbnail in view (centred, clamped),
   on load and whenever the active image changes. */
(function () {
  function centre(list) {
    var cur = list.querySelector('[aria-current="true"]');
    var li = cur && cur.closest('li');
    if (!li) return;
    var target = li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2;
    var max = list.scrollWidth - list.clientWidth;
    list.scrollLeft = Math.max(0, Math.min(max, target));
  }
  function all() { document.querySelectorAll('.thumbnail-list').forEach(centre); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.thumbnail-list, variant-selects')) setTimeout(all, 400);
  });
  /* quick view content arrives after load */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].target.closest && muts[i].target.closest('.quick-add-modal__content-info')) { setTimeout(all, 300); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Phone gallery: start on the active (variant) image and show dots inside the photo. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function setup(list) {
    if (!mq.matches || list.dataset.bomDots) return;
    list.dataset.bomDots = '1';
    var items = list.querySelectorAll(':scope > li');
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'bom-gdots';
    dots.setAttribute('aria-hidden', 'true');
    items.forEach(function () { dots.appendChild(document.createElement('i')); });
    list.closest('slider-component').after(dots);
    function current() {
      var mid = list.scrollLeft + list.clientWidth / 2, best = 0, bestD = Infinity;
      items.forEach(function (li, i) { var c = li.offsetLeft + li.offsetWidth / 2; var d = Math.abs(c - mid); if (d < bestD) { bestD = d; best = i; } });
      return best;
    }
    function paint() { var c = current(); dots.querySelectorAll('i').forEach(function (d, i) { d.classList.toggle('is-active', i === c); }); }
    function toActive() {
      var active = list.querySelector(':scope > li.is-active');
      // instant: the list has CSS smooth scrolling, which made the phone gallery visibly slide through every photo on load
      if (active) list.scrollTo({ left: active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2, behavior: 'instant' });
      paint();
    }
    toActive();
    window.addEventListener('load', function () { setTimeout(toActive, 50); });
    list.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
  }
  function all() { document.querySelectorAll('media-gallery .product__media-list').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
})();

/* Phone menu drawer */
if (!customElements.get('bom-mobile-nav')) {
  customElements.define('bom-mobile-nav', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return; this._bound = true;
      this.btn = this.querySelector('.bom-mnav__open');
      this.drawer = this.querySelector('.bom-mnav__drawer');
      this.overlay = this.querySelector('.bom-mnav__overlay');
      /* the sticky header is its own stacking context; the drawer lives on <body> */
      this.portal = document.createElement('div');
      this.portal.className = 'bom-mnav bom-mnav-portal';
      this.portal.append(this.overlay, this.drawer);
      document.body.appendChild(this.portal);
      this.btn.addEventListener('click', () => this.open());
      this.portal.querySelectorAll('[data-bom-mnav-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.portal.addEventListener('keyup', (e) => { if (e.code === 'Escape') this.close(); });
      /* the row text is a link; the toggle area opens the group instead of following it */
      this.portal.querySelectorAll('summary .bom-mnav__link, summary .bom-mnav__sublink').forEach((a) => {
        a.addEventListener('click', (e) => e.stopPropagation());
      });
    }
    open() {
      this.portal.classList.add('is-open'); document.body.classList.add('overflow-hidden');
      this.btn.setAttribute('aria-expanded', 'true');
      setTimeout(() => this.drawer.focus({ preventScroll: true }), 50);
    }
    close() {
      this.portal.classList.remove('is-open'); document.body.classList.remove('overflow-hidden');
      this.btn.setAttribute('aria-expanded', 'false'); this.btn.focus({ preventScroll: true });
    }
  });
}
